<template>
    <div>
        <div class="breadcrumbs" id="breadcrumbs">
            <router-link class="breadcrumb-link" to="/corporate-products">All Corporate Products</router-link>  &gt;
            <router-link class="breadcrumb-link" :to="'/corporate-products/' + item.id">{{ item.name }}</router-link>
        </div>
        <h3 style="width: 100%">
            {{ item.name }} <span>Corporate Product</span><span class="preview" v-if="team.plan!='pro'"> PREVIEW</span>
            <div v-if="itemLoaded && $store.state.currentUser.is_bb_admin && item.product_type !== 'kitted'" class="ws-button small ws-button-admin ml-2" style="float: right" @click="convertToKittedProduct">CONVERT TO KITTED BOX</div>
        </h3>
        <table id="product-summary" class="ws-table-summary">
            <thead>
            <tr>
                <th>Status</th>
                <th>Product Type</th>
                <th>Date Created</th>
                <th v-if="item.product_type == 'box'">Components</th>
                <!--<th v-if="item.product_type != 'box'" >Unit Value</th>-->
                <th>Unit Allocation Amount</th>
                <th v-if="item.reorder_moq > 1">Reorder MOQ</th>
                <th>Stock Status</th>
                <th>Total Sends</th>
            </tr>
            </thead>
            <tbody>
            <tr :class='"status-"+item.status'>
                <td class="field-status" data-label="Status" :class="'status-'+item.team_status"><div class="value">{{ item.team_status }}</div></td>
                <td class="field-type" data-label="Product Type"><div class="value">
                    <b>{{ item.product_type === 'box' ||  item.product_type === 'kitted' ? 'Gift Box' : 'Product'}}</b>
                </div></td>
                <td class="field-start_date" data-label="Date Created"><div class="value">{{ item.created_at }}</div></td>
                <td v-if="item.product_type == 'box'" data-label="Components" class="field-unit_value_components">{{ item.box_content.length }} items</td>
                <!--<td v-if="item.product_type != 'box'" data-label="Unit Value" class="field-unit_value_components"><b>£{{ item.price }}</b> per unit</td>-->
                <td class="allocation-status" data-label="Unit Allocation Amount">
                  <span v-if="item.allocated < 1" class="out-of-alloc">No allocated units</span>
                  <span v-else-if="item.allocated < 20"  class="low-alloc"><b>{{ item.allocated }} units</b> allocated</span>
                  <span v-else class="in-alloc"><b>{{ item.allocated }} units</b> allocated</span>
                </td>
                <td v-if="item.reorder_moq > 1" data-label="Reorder MOQ">{{ item.reorder_moq }} units min.</td>
                <td class="stock-status" data-label="Stock Status">
                    
                  <span v-if="item.stock < 1"  class="out-of-stock">Out of Stock</span>
                  <span v-else-if="item.allocated >= item.stock" class="in-stock"><b>{{item.stock }} units</b></span>
                  <span v-else class="in-stock">In Stock</span>
                </td>
                <td data-label="Total Sends" class="field-total_sends"><b>{{ item.count_sent }} units</b> sent</td>
            </tr>
            </tbody>
        </table>

        <div id="product-detail-info">
            <div class="product-image" :style="'background-image: url('+item.image_url+')'"></div>
            <h4>{{ item.name }}</h4>
            <div id="product-description" v-html="item.description"></div>
        </div>

        <div id="product-actions" class="tool-actions">
            <div class="tool-actions-left">
                <div v-if="item.product_type==='kitted'" class="ws-button ws-button-main" @click="openRestockModal(item.id)">REQUEST MORE UNITS</div>
            </div>
            <div class="tool-actions-right">
                <div v-if="itemLoaded && item.multi_allocated == false" @click="editProduct(item.id)" class="ws-button ws-button-secondary">EDIT PRODUCT</div>
                <div @click="updateProductStatus('paused')" class="ws-button ws-button-secondary" v-if="item.team_status !== 'paused'">PAUSE PRODUCT</div>
                <div @click="updateProductStatus('active')" class="ws-button ws-button-secondary" v-if="item.team_status !== 'active'">ACTIVATE PRODUCT</div>
            </div>
        </div>

        <div v-if="item.product_type === 'box'" class="wspro-product-listing" style="margin-bottom: 40px;">
            <h4>Gift Box Components</h4>
            <div class="wspro-product-list">
                <div v-for="boxItem in item.box_content" class="wspro-product-list-item" v-if="boxItem !== null">
                    <product-list-item :item="boxItem" location="gifting-campaigns" @open-restock-modal="openRestockModal"></product-list-item>
                </div>
            </div>
        </div>

        <div v-if="item.product_type === 'kitted' && item.components.length" style="margin-bottom: 40px;">
            <h4>Gift Box Components & Kitting Progress
                <div v-if="item.kitting_date" style="float: right">Expected Kitting Date: {{ item.kitting_date }}</div>
            </h4>
            
            <table id="list-of-kitting-components"  class="worksends-table">
                <thead>
                <tr>
                    <th class="field-c_name">Component Name</th>
                    <th class="field-quantity">Quantity</th>
                    <th class="field-date">Requested From Distributor</th>
                    <th class="field-date">Delivered to Bookblock</th>
                    <th class="field-date">Placed Into Gift Box</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="component in item.components">
                    <td class="field-c_name" data-label="Component Name">
                        <b>{{ component.name }}</b>
                    </td>
                    <td class="field-quantity" data-label="Quantity">
                        <template v-if="component.expected_quantity">
                            <b>{{ component.actual_quantity ?? component.expected_quantity }}</b> units
                        </template>
                        <template v-else>-
                        </template>
                    </td>
                    <td class="field-date" data-label="Requested From Distributor">
                        <div class="value">
                            <div v-if="component.requested_at" class="yesno yes">Yes
                                <div class="yesno-date">{{ formatDate(component.requested_at) }}</div>
                            </div>
                            <div v-else class="yesno no">No</div>
                        </div>
                    </td>
                    <td class="field-date" data-label="Delivered to Bookblock">
                        <div class="value">
                            <div v-if="component.delivered_at" class="yesno yes">Yes
                                <div class="yesno-date">{{ formatDate(component.delivered_at) }}</div>
                            </div>
                            <div v-else class="yesno no">No</div>
                        </div>
                    </td>
                    <td class="field-date" data-label="Placed Into Gift Box">
                        <div class="value">
                            <div v-if="component.kitted_at" class="yesno yes">Yes
                                <div class="yesno-date">{{ formatDate(component.kitted_at) }}</div>
                            </div>
                            <div v-else class="yesno no">No</div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <h4>Product Order History</h4>
        <table id="list-of-recipients"  class="worksends-table">
            <thead>
            <tr>
                <th class="field-r_name">Recipient Name</th>
                <th class="field-r_email">Recipient E-mail</th>
                <th class="field-o_quantity">Quantity</th>
                <th class="field-o_type">Order Type</th>
                <th class="field-o_date">Order Date</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order in productOrders.data">
                <td class="field-r_name" data-label="Recipient Name"><div class="value"><b>{{ order.first_name }} {{ order.last_name }}</b></div></td>
                <td class="field-r_email" data-label="Recipient E-mail"><div class="value">{{ order.email }}</div></td>
                <td class="field-o_quantity" data-label="Quantity"><div class="value">{{ order.quantity }}</div></td>
                <td class="field-o_type" data-label="Order Type"><div class="value"><router-link :to="'/campaigns/' + order.campaign_id">{{ order.campaign_name }}</router-link><br /><small>ID #{{ order.id }}</small></div></td>
                <td class="field-o_date" data-label="Order Date"><div class="value">{{ order.registered_at }}</div></td>
            </tr>
            </tbody>
        </table>
        <ws-table-meta :meta="productOrders.meta" sum="There are % product orders in total."></ws-table-meta>

        <product-restock-modal v-if="modals.productRestock" :fetch-item="true" :product-id="restockProductId" @created="modals.productRestock = false"></product-restock-modal>
        <product-edit-modal v-if="modals.productEdit" @updated="modals.productEdit = false"></product-edit-modal>
    </div>
</template>

<script>
import ProductListItem from "@/components/ProductListItem";
import ProductRestockModal from "@/pages/corporate-products/ProductRestockModal";
import ProductEditModal from "@/pages/corporate-products/ProductEditModal";

export default {
    name: "ProductsDetail",
    components: {ProductListItem, ProductRestockModal, ProductEditModal},
    data() {
        return {
            pageParams: {
                pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
                search: {val: ""},
                filters: {}
            },
            restockProductId: null,
            itemLoaded: false,
        }
    },
    methods: {
        getPage(params) {
            return this.getPageHandler({
                waitName: 'gb_products.detail',
                action: 'fetchProductOrders', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: {productId: this.$route.params.id}
            });
        },
        async fetchData() {
            return this.dispatchWaitAndNotify('fetchProduct', {productId: this.$route.params.id, fetchDemoContent: this.team.plan=='pro' ? false : true}, false, true)
                    .finally(() => {
                        this.itemLoaded = true;
                    });
            // this.dispatchWaitAndNotify('fetchProductOrders', {productId: this.$route.params.id}, false, true);
        },
        async updateProductStatus(status) {
            if (!this.demoCheck()) return;
            if (!this.proCheck('Updating product status')) return;
            
            await this.dispatchWaitAndNotify('updateProduct', {productId:this.$route.params.id, payload:{team_status: status}});
            await this.dispatchWaitAndNotify('fetchProduct', {productId: this.$route.params.id}, false, true);
        },
        editProduct(id) {
            if (!this.proCheck('Editing corporate products')) return;
            this.modals.productEdit = true;
        },
        openRestockModal(id) {
            if (!this.proCheck('Requesting product restock')) return;
            this.restockProductId = id;
            this.modals.productRestock = true;
        },
        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleString();
        },
        async convertToKittedProduct() {
            if (!window.confirm('This will convert this product to Kitted Box. Do you want to continue?')) return;
            await this.dispatchWaitAndNotify('updateProduct', {productId:this.$route.params.id, payload:{action: 'convert_to_kitted'}});
        },
    },
    async mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
        this.itemLoaded = false;
        try {
            await this.getPage({init: true});
            await this.fetchData();
        } catch (e) {
            if (e.response?.status === 404) {
                this.$router.push('corporate-products');
            }
            console.log({e});
        }
    },
    computed: {
        item() {
            return this.$store.state.product.detail;
        },
        productOrders() {
            return this.$store.state.product.orders.index;
        },
        modals() {
            return this.$store.state.modals;
        },
        team() {
            return this.$store.state.team.detail;
        },
    },
}
</script>

<style scoped>

</style>
